import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { TrainerSidebar } from '@/features/TrainerLayout/TrainerSidebar';
import { TrainerTopBar } from '@/features/TrainerLayout/TrainerTopBar';

export const Route = createFileRoute('/trainer')({
  component: TrainerLayout,
});

function TrainerLayout() {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== 'trainer' && user.role !== 'super_admin') {
      navigate({ to: '/dashboard' });
    }
  }, [user, navigate]);

  if (!user || (user.role !== 'trainer' && user.role !== 'super_admin')) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Access restricted to KodPrep trainers.
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden bg-muted/20">
      <TrainerSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TrainerTopBar unreadCount={0} />
        <main
          className="flex flex-1 flex-col overflow-y-auto p-6 [scrollbar-gutter:stable]"
          style={{
            backgroundImage: [
              'radial-gradient(circle, rgba(26,23,20,0.12) 1px, transparent 1px)',
              'radial-gradient(ellipse 900px 700px at top right, rgba(232, 102, 13, 0.18) 0%, transparent 65%)',
              'radial-gradient(ellipse 500px 400px at 5% 95%, rgba(124, 58, 237, 0.10) 0%, transparent 55%)',
            ].join(', '),
            backgroundSize: '22px 22px, auto, auto',
            backgroundColor: '#faf8f6',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
